import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
// import {getUrlParameters} from '../../../common/util/urlParameters';
import * as MessageActions from '../../../common/messageBox/actions/actions';

export const getWtsCoursesStatus = () => apiActionCreator({
  'endpoint': '/wts/catalog/courses-status',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_COURSES_STATUS,
    ActionTypes.FETCHED_WTS_COURSES_STATUS,
    [
      ActionTypes.FETCHED_WTS_COURSES_STATUS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const changeWtsCourseStatusSelected = (courseStatusSelected) => ({
  'type': ActionTypes.CHANGE_WTS_COURSE_STATUS_SELECTED,
  'payload': courseStatusSelected,
});


export const createWtsCoursesStatus = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/catalog/courses-status',
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_WTS_COURSES_STATUS,
        [
          () => {
            dispatch(getWtsCoursesStatus());
            return {'type': ActionTypes.CREATED_WTS_COURSES_STATUS};
          },
          MessageActions.addMessageBoxInfo('Estado de curso creado satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_WTS_COURSES_STATUS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const updateWtsCoursesStatus = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/catalog/courses-status',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_COURSES_STATUS,
        [
          () => {
            dispatch(getWtsCoursesStatus());
            return {'type': ActionTypes.UPDATED_WTS_COURSES_STATUS};
          },
          MessageActions.addMessageBoxInfo('Estado de curso modificado satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_COURSES_STATUS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};
